import Bugsnag from "@bugsnag/js";

Bugsnag.start({
  apiKey: "a32e9c2020ed2c61ed0448571243fc66",
  onError: (event) => {
    if (isBrowserNoise(event)) return false;

    // attaches evidence about what bundles are running
    event.addMetadata("app", {
      bundles: Array.from(document.querySelectorAll("script")).map(
        (it) => it.src,
      ),
    });

    const state = window.store && window.store.getState();

    // A loja é o "usuário" do Bugsnag: dá para buscar os erros de uma loja e
    // ver quantas lojas um erro atinge.
    const shop = shopFromState(state);
    if (shop) {
      event.setUser(shop.id, undefined, shop.name);
      event.addMetadata("loja", shop);
    }

    // snapshots the current UI state
    event.addMetadata("store", state);
  },
});

/**
 * Erros de script que o navegador injeta na página, e não do app. O
 * `_AutofillCallbackHandler` vem do navegador interno do Facebook/Instagram no
 * iOS (o stack aponta para a própria URL da loja, "global code").
 */
const BROWSER_NOISE = ["_AutofillCallbackHandler"];

export function isBrowserNoise(event) {
  const message = event.errors?.[0]?.errorMessage || "";
  return BROWSER_NOISE.some((noise) => message.includes(noise));
}

/**
 * Identifica a loja a partir do estado do Redux. Antes de a loja carregar (ou
 * quando o carregamento falha, que é justamente a tela de erro) só existe o
 * namespace da URL; ele vira o nome, e o id fica vazio.
 */
export function shopFromState(state) {
  if (!state) return null;
  const { shop = {}, appState = {} } = state;
  const namespace = appState.namespace || shop.uri || "";
  if (!shop.id && !namespace) return null;

  return {
    id: shop.id ? String(shop.id) : undefined,
    name: shop.name || namespace,
    namespace,
    mode: shop.mode,
  };
}

/**
 * Notify our error tracker (currently Busgnag).
 *
 * @param {Error} payload `Error` instance with the stack trace.
 * @param {Object} [options] `severity` ("info", "warning", "error") e
 *   `metadata` ({ seção: { chave: valor } }) do evento.
 */
export async function notifyErrorTracker(error, { severity, metadata } = {}) {
  Bugsnag.notify(error, (event) => {
    if (severity) event.severity = severity;
    Object.keys(metadata || {}).forEach((secao) =>
      event.addMetadata(secao, metadata[secao]),
    );
  });
}
